// Correctif (idee CGM/ClickDoc) : listes partagees des cases a cocher du
// formulaire "informations avant consultation" (espace patient) et de leur
// affichage cote medecin. Un seul point de verite pour les codes de tag et
// leur cle de traduction (voir i18n/translations.js), utilise a la fois par
// PatientDashboard.js (formulaire) et DoctorDashboard.js (affichage), pour
// que les deux ne puissent jamais diverger.
//
// Le code (`code`) est ce qui est envoye/stocke en base — stable, jamais
// traduit. Le libelle affiche vient de la cle de traduction (`labelKey`).

export const PRE_VISIT_ALLERGY_OPTIONS = [
  { code: 'penicillin_antibiotics', labelKey: 'pv_allergy_penicillin' },
  { code: 'aspirin_nsaid', labelKey: 'pv_allergy_aspirin_nsaid' },
  { code: 'latex', labelKey: 'pv_allergy_latex' },
  { code: 'iodine_contrast', labelKey: 'pv_allergy_iodine' },
  { code: 'nuts_peanuts', labelKey: 'pv_allergy_nuts' },
  { code: 'sulfa_drugs', labelKey: 'pv_allergy_sulfa' },
  { code: 'local_anesthesia', labelKey: 'pv_allergy_anesthesia' },
  { code: 'insect_stings', labelKey: 'pv_allergy_insects' },
  { code: 'none_known', labelKey: 'pv_allergy_none' },
];

export const PRE_VISIT_MEDICATION_OPTIONS = [
  { code: 'anticoagulants', labelKey: 'pv_med_anticoagulants' },
  { code: 'antidiabetics', labelKey: 'pv_med_antidiabetics' },
  { code: 'antihypertensives', labelKey: 'pv_med_antihypertensives' },
  { code: 'corticosteroids', labelKey: 'pv_med_corticosteroids' },
  { code: 'anticonvulsants', labelKey: 'pv_med_anticonvulsants' },
  { code: 'heart_medication', labelKey: 'pv_med_heart' },
  { code: 'psychiatric_anxiolytics', labelKey: 'pv_med_psychiatric' },
  { code: 'hormonal_contraception', labelKey: 'pv_med_contraception' },
  { code: 'none_current', labelKey: 'pv_med_none' },
];

export const PRE_VISIT_CONTEXT_OPTIONS = [
  { code: 'first_visit_doctor', labelKey: 'pv_ctx_first_visit' },
  { code: 'routine_followup', labelKey: 'pv_ctx_followup' },
  { code: 'pregnant', labelKey: 'pv_ctx_pregnant' },
  { code: 'has_exam_results', labelKey: 'pv_ctx_exam_results' },
  { code: 'needs_medical_certificate', labelKey: 'pv_ctx_certificate' },
  { code: 'urgent_significant_pain', labelKey: 'pv_ctx_urgent' },
  { code: 'prescription_renewal_only', labelKey: 'pv_ctx_renewal' },
];

// Petit utilitaire partage : transforme une liste de codes en libelles
// traduits (les codes inconnus, ex. si la liste evolue plus tard, sont
// simplement ignores plutot que d'afficher une cle brute au medecin).
export function preVisitTagLabels(tags, options, t) {
  if (!tags || !tags.length) return [];
  const byCode = Object.fromEntries(options.map((o) => [o.code, o.labelKey]));
  return tags.map((tag) => byCode[tag]).filter(Boolean).map((key) => t(key));
}
